import { useMsal } from "@azure/msal-react";
import type { PopupRequest } from "@azure/msal-browser";

export function useLogin() {
  const { instance } = useMsal();
  return (loginRequest: PopupRequest) => instance.loginPopup(loginRequest);
}
